The input parameter for the `verifyCandidate` mutation.
